__turbopack_context__.v({
  "enrollCTAContainer": "EnrollNowButton-module-scss-module__JFJW3a__enrollCTAContainer",
  "enrollCTAContainerInner": "EnrollNowButton-module-scss-module__JFJW3a__enrollCTAContainerInner",
});
